// mediaBlock.ts
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class BlockMedia {
    private mediaItems: NodeListOf<HTMLElement>;

    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        this.mediaItems = document.querySelectorAll(".blockMedia img");
        this.initAnimations();
    }

    private initAnimations(): void {
        this.mediaItems.forEach((item) => {
            // Wrap your image in a container to prevent layout shifting
            const container = item.parentElement as HTMLElement;
            container.style.overflow = "hidden";

            const isLargeScreen = window.innerWidth >= 800; // 50rem = 800px

            if (isLargeScreen) {
                // Create a mask animation with rounded corners expanding from center
                gsap.fromTo(
                    item,
                    {
                        y: "-20%", // start slightly above
                        scale: 1.1,
                        clipPath: "inset(30% 38% 30% 38% round 40px)", // Small rounded rectangle in center
                    },
                    {
                        y: "0%", // move slightly downward as you scroll
                        scale: 1,
                        clipPath: "inset(0% 0% 0% 0% round 0px)", // Expand to full size, corners straighten
                        ease: "none",
                        scrollTrigger: {
                            trigger: container,
                            start: "top 80%", // when container enters viewport
                            end: "top 40%", // when it leaves
                            scrub: true, // makes it linked to scroll position
                        },
                    }
                );
            } else {
                // Create a mask animation with rounded corners expanding from center
                gsap.fromTo(
                    item,
                    {
                        y: "-20%", // start slightly above
                        scale: 1.1,
                        clipPath: "inset(10% 18% 10% 18% round 8px)", // Small rounded rectangle in center
                    },
                    {
                        y: "0%", // move slightly downward as you scroll
                        scale: 1,
                        clipPath: "inset(0% 0% 0% 0% round 0px)", // Expand to full size, corners straighten
                        ease: "none",
                        scrollTrigger: {
                            trigger: container,
                            start: "top 100%", // when container enters viewport
                            end: "top 70%", // when it leaves
                            scrub: true, // makes it linked to scroll position
                        },
                    }
                );
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new BlockMedia();
});